// Generated by pnpm agent:tools from locally maintained provider definitions.
export default {
  "dataforseo_keyword_ideas": {
    "id": "dataforseo_keyword_ideas",
    "name": "Keyword Ideas",
    "description": "keyword ideas",
    "version": "2.0.0",
    "params": {
      "parameters": {
        "type": "object",
        "required": false,
        "visibility": "user-or-llm",
        "description": "JSON keyword and location parameters"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "dataforseo_search_volumes": {
    "id": "dataforseo_search_volumes",
    "name": "Search Volumes",
    "description": "search volumes",
    "version": "2.0.0",
    "params": {
      "parameters": {
        "type": "object",
        "required": false,
        "visibility": "user-or-llm",
        "description": "JSON keyword and location parameters"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "dingtalk_read_document": {
    "id": "dingtalk_read_document",
    "name": "Read DingTalk document blocks",
    "description": "Read blocks from a document accessible through the DingTalk document suite API",
    "version": "1.0.0",
    "params": {
      "accessToken": {
        "type": "string",
        "required": true,
        "visibility": "user-only",
        "description": "Connected app access token"
      },
      "documentId": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "Document docKey"
      },
      "operatorId": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "Authorized operator unionId"
      }
    },
    "oauth": {
      "required": true,
      "credentialKind": "service-account",
      "provider": "dingtalk"
    },
    "hostedApiKey": "none"
  },
  "dingtalk_read_table": {
    "id": "dingtalk_read_table",
    "name": "Read DingTalk table",
    "description": "Read a cell range from an authorized DingTalk workbook",
    "version": "1.0.0",
    "params": {
      "accessToken": {
        "type": "string",
        "required": true,
        "visibility": "user-only",
        "description": "Connected app access token"
      },
      "workbookId": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "Workbook ID"
      },
      "sheetId": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "Sheet ID"
      },
      "range": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "Cell range, for example A1:Z1000"
      },
      "operatorId": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "Authorized operator unionId"
      }
    },
    "oauth": {
      "required": true,
      "credentialKind": "service-account",
      "provider": "dingtalk"
    },
    "hostedApiKey": "none"
  },
  "dingtalk_send_message": {
    "id": "dingtalk_send_message",
    "name": "Send DingTalk message",
    "description": "Send a text message with an enterprise app robot",
    "version": "1.0.0",
    "params": {
      "accessToken": {
        "type": "string",
        "required": true,
        "visibility": "user-only",
        "description": "Connected app access token"
      },
      "robotCode": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "Enterprise app robot code"
      },
      "openConversationId": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "Group openConversationId"
      },
      "text": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "Message text"
      }
    },
    "oauth": {
      "required": true,
      "credentialKind": "service-account",
      "provider": "dingtalk"
    },
    "hostedApiKey": "none"
  },
  "exa_agent": {
    "id": "exa_agent",
    "name": "Agent",
    "description": "agent",
    "version": "2.0.0",
    "params": {
      "query": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "The research question or instructions for the agent"
      },
      "effort": {
        "type": "string",
        "required": false,
        "visibility": "user-only",
        "description": "Cost and depth tradeoff: minimal, low, medium, high, xhigh, or auto (default: auto)"
      },
      "outputSchema": {
        "type": "json",
        "required": false,
        "visibility": "user-or-llm",
        "description": "JSON Schema describing the structured result to return. Returned in the structured output."
      },
      "systemPrompt": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Additional guidance for how the agent should behave or format its answer"
      },
      "previousRunId": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "ID of a completed agent run to continue from, for follow-up questions"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "exa_answer": {
    "id": "exa_answer",
    "name": "Answer",
    "description": "answer",
    "version": "2.0.0",
    "params": {
      "query": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "The question to answer"
      },
      "text": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Include the full page text of each cited source (default: false). This does not affect the answer itself."
      },
      "outputSchema": {
        "type": "json",
        "required": false,
        "visibility": "user-or-llm",
        "description": "JSON Schema describing the answer shape. When supplied, the answer is returned as a structured object instead of a string."
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "exa_find_similar_links": {
    "id": "exa_find_similar_links",
    "name": "Find Similar Links",
    "description": "find similar links",
    "version": "2.0.0",
    "params": {
      "url": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "The URL to find similar links for"
      },
      "numResults": {
        "type": "number",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Number of similar links to return (1-100). Default: 10"
      },
      "text": {
        "type": "boolean",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Whether to include the full text of the similar pages"
      },
      "includeDomains": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Comma-separated list of domains to include in results (e.g., \"github.com, stackoverflow.com\")"
      },
      "excludeDomains": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Comma-separated list of domains to exclude from results (e.g., \"reddit.com, pinterest.com\")"
      },
      "excludeSourceDomain": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Exclude the source domain from results (default: false)"
      },
      "category": {
        "type": "string",
        "required": false,
        "visibility": "user-only",
        "description": "Filter by category: company, publication, news, personal site, financial report, people"
      },
      "highlights": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Include highlighted snippets in results (default: false)"
      },
      "summary": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Include AI-generated summaries in results (default: false)"
      },
      "maxAgeHours": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Cache freshness in hours (-1 to 720). 0 always crawls live, -1 uses cache only. Cannot be combined with livecrawl."
      },
      "livecrawlTimeout": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Live crawl timeout in milliseconds (max 90000). Default: 10000"
      },
      "livecrawl": {
        "type": "string",
        "required": false,
        "visibility": "user-only",
        "description": "Deprecated: use maxAgeHours instead. Live crawling mode: never, fallback, always, or preferred"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "exa_get_contents": {
    "id": "exa_get_contents",
    "name": "Get Contents",
    "description": "get contents",
    "version": "2.0.0",
    "params": {
      "urls": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Comma-separated list of URLs to retrieve content from (1-100). Provide either urls or ids, not both."
      },
      "ids": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Comma-separated list of result IDs from a prior the tool search (1-100). Provide either urls or ids, not both."
      },
      "text": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "If true, returns full page text with default settings. If false, disables text return."
      },
      "summary": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Include an AI-generated summary of each page (default: false)"
      },
      "summaryQuery": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Query to guide the summary generation"
      },
      "subpages": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Number of subpages to crawl from the provided URLs (0-100)"
      },
      "subpageTarget": {
        "type": "string",
        "required": false,
        "visibility": "user-only",
        "description": "Comma-separated keywords to target specific subpages (e.g., \"docs,tutorial,about\")"
      },
      "highlights": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Include highlighted snippets in results (default: false)"
      },
      "extrasLinks": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Number of links to extract from each page (0-1000). Default: 0"
      },
      "extrasImageLinks": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Number of image URLs to extract from each page (0-1000). Default: 0"
      },
      "maxAgeHours": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Cache freshness in hours (-1 to 720). 0 always crawls live, -1 uses cache only. Cannot be combined with livecrawl."
      },
      "livecrawlTimeout": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Live crawl timeout in milliseconds (max 90000). Default: 10000"
      },
      "livecrawl": {
        "type": "string",
        "required": false,
        "visibility": "user-only",
        "description": "Deprecated: use maxAgeHours instead. Live crawling mode: never, fallback, always, or preferred"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "exa_search": {
    "id": "exa_search",
    "name": "Search",
    "description": "search",
    "version": "2.0.0",
    "params": {
      "query": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "The search query to execute"
      },
      "numResults": {
        "type": "number",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Number of results to return (1-100). Default: 10"
      },
      "type": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Search type: \"instant\", \"fast\", \"auto\", \"deep-lite\", \"deep\", or \"deep-reasoning\". Default: \"auto\""
      },
      "includeDomains": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Comma-separated list of domains to include in results (e.g., \"github.com, stackoverflow.com\")"
      },
      "excludeDomains": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Comma-separated list of domains to exclude from results (e.g., \"reddit.com, pinterest.com\")"
      },
      "category": {
        "type": "string",
        "required": false,
        "visibility": "user-only",
        "description": "Filter by category: company, publication, news, personal site, financial report, people"
      },
      "text": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Include full text content in results (default: false)"
      },
      "highlights": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Include highlighted snippets in results (default: false)"
      },
      "summary": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Include AI-generated summaries in results (default: false)"
      },
      "summaryQuery": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Query to focus the generated summaries on a specific question"
      },
      "subpages": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Number of subpages to crawl per result (0-100). Default: 0"
      },
      "subpageTarget": {
        "type": "string",
        "required": false,
        "visibility": "user-only",
        "description": "Comma-separated keywords to target specific subpages (e.g., \"docs,pricing,about\")"
      },
      "extrasLinks": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Number of links to extract from each result page (0-1000). Default: 0"
      },
      "extrasImageLinks": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Number of image URLs to extract from each result page (0-1000). Default: 0"
      },
      "outputSchema": {
        "type": "json",
        "required": false,
        "visibility": "user-or-llm",
        "description": "JSON Schema describing a synthesized answer to build from the results. Returned in structuredOutput."
      },
      "systemPrompt": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Additional guidance for generating the synthesized output"
      },
      "userLocation": {
        "type": "string",
        "required": false,
        "visibility": "user-only",
        "description": "Two-letter ISO country code to localize results (e.g., \"US\")"
      },
      "maxAgeHours": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Cache freshness in hours (-1 to 720). 0 always crawls live, -1 uses cache only. Cannot be combined with livecrawl."
      },
      "livecrawlTimeout": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Live crawl timeout in milliseconds (max 90000). Default: 10000"
      },
      "livecrawl": {
        "type": "string",
        "required": false,
        "visibility": "user-only",
        "description": "Deprecated: use maxAgeHours instead. Live crawling mode: never, fallback, always, or preferred"
      },
      "startPublishedDate": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Only include results published on or after this ISO 8601 date (e.g., \"2024-01-01\" or \"2024-01-01T00:00:00.000Z\")"
      },
      "endPublishedDate": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Only include results published on or before this ISO 8601 date"
      },
      "startCrawlDate": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Deprecated: use startPublishedDate. Only include results crawled on or after this ISO 8601 date"
      },
      "endCrawlDate": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Deprecated: use endPublishedDate. Only include results crawled on or before this ISO 8601 date"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "feishu_read_document": {
    "id": "feishu_read_document",
    "name": "Read Feishu document",
    "description": "Read the plain text of an authorized Feishu docx document",
    "version": "1.0.0",
    "params": {
      "accessToken": {
        "type": "string",
        "required": true,
        "visibility": "user-only",
        "description": "Connected app access token"
      },
      "documentId": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "Feishu docx document ID, not a wiki node token"
      }
    },
    "oauth": {
      "required": true,
      "credentialKind": "service-account",
      "provider": "feishu"
    },
    "hostedApiKey": "none"
  },
  "feishu_send_message": {
    "id": "feishu_send_message",
    "name": "Send Feishu message",
    "description": "Send a text message to a Feishu chat",
    "version": "1.0.0",
    "params": {
      "accessToken": {
        "type": "string",
        "required": true,
        "visibility": "user-only",
        "description": "Connected app access token"
      },
      "chatId": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "Chat ID (oc_...)"
      },
      "text": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "Message text"
      }
    },
    "oauth": {
      "required": true,
      "credentialKind": "service-account",
      "provider": "feishu"
    },
    "hostedApiKey": "none"
  },
  "firecrawl_agent": {
    "id": "firecrawl_agent",
    "name": "Agent",
    "description": "agent",
    "version": "2.0.0",
    "params": {
      "prompt": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Natural language description of the data to extract (max 10,000 characters)"
      },
      "urls": {
        "type": "json",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Optional array of URLs to focus the agent on (e.g., [\"https://example.com\", \"https://docs.example.com\"])"
      },
      "schema": {
        "type": "json",
        "required": false,
        "visibility": "user-or-llm",
        "description": "JSON Schema defining the structure of data to extract"
      },
      "maxCredits": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Maximum credits to spend on this agent task"
      },
      "strictConstrainToURLs": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "If true, agent will only visit URLs provided in the urls array"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "firecrawl_batch_scrape_status": {
    "id": "firecrawl_batch_scrape_status",
    "name": "Batch Scrape Status",
    "description": "batch scrape status",
    "version": "2.0.0",
    "params": {
      "jobId": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "The ID of the batch scrape job to check"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "firecrawl_parse": {
    "id": "firecrawl_parse",
    "name": "Parse",
    "description": "parse",
    "version": "2.0.0",
    "params": {
      "file": {
        "type": "file",
        "required": false,
        "visibility": "user-only",
        "description": "Document file to be parsed"
      },
      "formats": {
        "type": "array",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Output formats to return (e.g., [\"markdown\"]). Defaults to markdown."
      },
      "onlyMainContent": {
        "type": "boolean",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Exclude headers, navs, footers. Defaults to true."
      },
      "includeTags": {
        "type": "array",
        "required": false,
        "visibility": "user-or-llm",
        "description": "HTML tags to include"
      },
      "excludeTags": {
        "type": "array",
        "required": false,
        "visibility": "user-or-llm",
        "description": "HTML tags to exclude"
      },
      "timeout": {
        "type": "number",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Timeout in milliseconds (max 300000). Defaults to 30000."
      },
      "parsers": {
        "type": "array",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Parser configuration (e.g., [{ \"type\": \"pdf\" }])"
      },
      "removeBase64Images": {
        "type": "boolean",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Remove base64 images, keep alt text. Defaults to true."
      },
      "blockAds": {
        "type": "boolean",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Block ads and popups. Defaults to true."
      },
      "proxy": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Proxy mode: \"basic\" or \"auto\""
      },
      "zeroDataRetention": {
        "type": "boolean",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Enable zero data retention. Defaults to false."
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "firecrawl_scrape": {
    "id": "firecrawl_scrape",
    "name": "Scrape",
    "description": "scrape",
    "version": "2.0.0",
    "params": {
      "url": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "The URL to scrape content from (e.g., \"https://example.com/page\")"
      },
      "formats": {
        "type": "json",
        "required": false,
        "visibility": "hidden",
        "description": "Output formats supplied by existing the tool block configurations"
      },
      "scrapeOptions": {
        "type": "json",
        "required": false,
        "visibility": "hidden",
        "description": "Options for content scraping"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "firecrawl_search": {
    "id": "firecrawl_search",
    "name": "Search",
    "description": "search",
    "version": "2.0.0",
    "params": {
      "query": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "The search query to use"
      },
      "scrapeOptions": {
        "type": "json",
        "required": false,
        "visibility": "hidden",
        "description": "Advanced scrape options supplied by existing configurations"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "firecrawl_batch_scrape": {
    "id": "firecrawl_batch_scrape",
    "name": "Batch Scrape",
    "description": "batch scrape",
    "version": "2.0.0",
    "params": {
      "urls": {
        "type": "json",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Array of URLs to scrape (e.g., [\"https://example.com/page1\", \"https://example.com/page2\"])"
      },
      "formats": {
        "type": "json",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Output formats for scraped content (e.g., [\"markdown\"], [\"markdown\", \"html\"])"
      },
      "onlyMainContent": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Extract only main content from pages"
      },
      "maxConcurrency": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Maximum number of concurrent scrapes"
      },
      "ignoreInvalidURLs": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Skip invalid URLs instead of failing the batch (default: true)"
      },
      "scrapeOptions": {
        "type": "json",
        "required": false,
        "visibility": "hidden",
        "description": "Advanced scraping configuration options"
      },
      "zeroDataRetention": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Enable zero data retention"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "firecrawl_cancel_crawl": {
    "id": "firecrawl_cancel_crawl",
    "name": "Cancel Crawl",
    "description": "cancel crawl",
    "version": "2.0.0",
    "params": {
      "jobId": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "The ID of the crawl job to cancel"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "firecrawl_crawl_status": {
    "id": "firecrawl_crawl_status",
    "name": "Crawl Status",
    "description": "crawl status",
    "version": "2.0.0",
    "params": {
      "jobId": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "The ID of the crawl job to check"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "firecrawl_crawl": {
    "id": "firecrawl_crawl",
    "name": "Crawl",
    "description": "crawl",
    "version": "2.0.0",
    "params": {
      "url": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "The website URL to crawl (e.g., \"https://example.com\" or \"https://docs.example.com/guide\")"
      },
      "limit": {
        "type": "number",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Maximum number of pages to crawl (e.g., 50, 100, 500). Default: 100"
      },
      "maxDepth": {
        "type": "number",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Maximum depth to crawl from the starting URL (e.g., 1, 2, 3). Controls how many levels deep to follow links"
      },
      "formats": {
        "type": "json",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Output formats for scraped content (e.g., [\"markdown\"], [\"markdown\", \"html\"], [\"markdown\", \"links\"])"
      },
      "prompt": {
        "type": "string",
        "required": false,
        "visibility": "hidden",
        "description": "Natural-language crawl guidance supplied by existing configurations"
      },
      "scrapeOptions": {
        "type": "json",
        "required": false,
        "visibility": "hidden",
        "description": "Advanced scrape options supplied by existing configurations"
      },
      "excludePaths": {
        "type": "json",
        "required": false,
        "visibility": "user-or-llm",
        "description": "URL paths to exclude from crawling (e.g., [\"/blog/*\", \"/admin/*\", \"/*.pdf\"])"
      },
      "includePaths": {
        "type": "json",
        "required": false,
        "visibility": "user-or-llm",
        "description": "URL paths to include in crawling (e.g., [\"/docs/*\", \"/api/*\"]). Only these paths will be crawled"
      },
      "onlyMainContent": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Extract only main content from pages"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "firecrawl_credit_usage": {
    "id": "firecrawl_credit_usage",
    "name": "Credit Usage",
    "description": "credit usage",
    "version": "2.0.0",
    "params": {
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "firecrawl_extract_status": {
    "id": "firecrawl_extract_status",
    "name": "Extract Status",
    "description": "extract status",
    "version": "2.0.0",
    "params": {
      "jobId": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "The ID of the extract job to check"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "firecrawl_extract": {
    "id": "firecrawl_extract",
    "name": "Extract",
    "description": "extract",
    "version": "2.0.0",
    "params": {
      "urls": {
        "type": "json",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Array of URLs to extract data from (e.g., [\"https://example.com/page1\", \"https://example.com/page2\"] or [\"https://example.com/*\"])"
      },
      "prompt": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Natural language guidance for the extraction process"
      },
      "schema": {
        "type": "json",
        "required": false,
        "visibility": "user-or-llm",
        "description": "JSON Schema defining the structure of data to extract"
      },
      "enableWebSearch": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Enable web search to find supplementary information (default: false)"
      },
      "ignoreSitemap": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Ignore sitemap.xml files during scanning (default: false)"
      },
      "includeSubdomains": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Extend scanning to subdomains (default: true)"
      },
      "showSources": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Return data sources in the response (default: false)"
      },
      "ignoreInvalidURLs": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Skip invalid URLs in the array (default: true)"
      },
      "scrapeOptions": {
        "type": "json",
        "required": false,
        "visibility": "hidden",
        "description": "Advanced scraping configuration options"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "firecrawl_map": {
    "id": "firecrawl_map",
    "name": "Map",
    "description": "map",
    "version": "2.0.0",
    "params": {
      "url": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "The base URL to map and discover links from (e.g., \"https://example.com\")"
      },
      "search": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Filter results by relevance to a search term (e.g., \"blog\")"
      },
      "sitemap": {
        "type": "string",
        "required": false,
        "visibility": "user-only",
        "description": "Controls sitemap usage: \"skip\", \"include\" (default), or \"only\""
      },
      "includeSubdomains": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Whether to include URLs from subdomains (default: true)"
      },
      "ignoreQueryParameters": {
        "type": "boolean",
        "required": false,
        "visibility": "user-only",
        "description": "Exclude URLs containing query strings (default: true)"
      },
      "limit": {
        "type": "number",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Maximum number of links to return (e.g., 100, 1000, 5000). Max: 100,000, default: 5,000"
      },
      "timeout": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Request timeout in milliseconds"
      },
      "location": {
        "type": "json",
        "required": false,
        "visibility": "hidden",
        "description": "Geographic context for proxying (country, languages)"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "parallel_deep_research": {
    "id": "parallel_deep_research",
    "name": "Deep Research",
    "description": "deep research",
    "version": "2.0.0",
    "params": {
      "input": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Research query or question (up to 15,000 characters)"
      },
      "output_format": {
        "type": "string",
        "required": false,
        "visibility": "user-only",
        "description": "Output format: text for a markdown report with inline citations, auto for a structured JSON object that needs the pro tier or higher (default: text)"
      },
      "processor": {
        "type": "string",
        "required": false,
        "visibility": "user-only",
        "description": "Processing tier: core, core2x, pro, ultra, ultra2x, ultra4x, ultra8x, or a -fast variant (default: pro)"
      },
      "include_domains": {
        "type": "string",
        "required": false,
        "visibility": "user-only",
        "description": "Comma-separated list of domains to restrict research to (source policy)"
      },
      "exclude_domains": {
        "type": "string",
        "required": false,
        "visibility": "user-only",
        "description": "Comma-separated list of domains to exclude from research (source policy)"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "parallel_extract": {
    "id": "parallel_extract",
    "name": "Extract",
    "description": "extract",
    "version": "2.0.0",
    "params": {
      "urls": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Comma-separated list of URLs to extract information from (up to 20)"
      },
      "objective": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "What information to extract from the provided URLs (up to 5,000 characters)"
      },
      "full_content": {
        "type": "boolean",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Include full page content as markdown in addition to excerpts (default: false)"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "parallel_search": {
    "id": "parallel_search",
    "name": "Search",
    "description": "search",
    "version": "2.0.0",
    "params": {
      "search_queries": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Comma-separated list of concise keyword search queries (3-6 words each). At least one is required"
      },
      "objective": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Natural-language description of the search intent used to rank and excerpt results"
      },
      "mode": {
        "type": "string",
        "required": false,
        "visibility": "user-only",
        "description": "Search mode: turbo, fast, basic, or advanced (default: advanced)"
      },
      "max_results": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Maximum number of results to return (default: 10, max: 20)"
      },
      "max_chars_per_result": {
        "type": "number",
        "required": false,
        "visibility": "user-only",
        "description": "Maximum characters of excerpts per result"
      },
      "include_domains": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Comma-separated list of domains to restrict search results to"
      },
      "exclude_domains": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Comma-separated list of domains to exclude from search results"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "serpapi_google_search": {
    "id": "serpapi_google_search",
    "name": "Google Search",
    "description": "google search",
    "version": "2.0.0",
    "params": {
      "parameters": {
        "type": "object",
        "required": false,
        "visibility": "user-or-llm",
        "description": "JSON search or video parameters"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "serpapi_youtube_video_transcript": {
    "id": "serpapi_youtube_video_transcript",
    "name": "Youtube Video Transcript",
    "description": "youtube video transcript",
    "version": "2.0.0",
    "params": {
      "parameters": {
        "type": "object",
        "required": false,
        "visibility": "user-or-llm",
        "description": "JSON search or video parameters"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "serpapi_youtube_data": {
    "id": "serpapi_youtube_data",
    "name": "Youtube Data",
    "description": "youtube data",
    "version": "2.0.0",
    "params": {
      "parameters": {
        "type": "object",
        "required": false,
        "visibility": "user-or-llm",
        "description": "JSON search or video parameters"
      },
      "query": {
        "type": "string",
        "required": false,
        "description": "query"
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "serper_search": {
    "id": "serper_search",
    "name": "Search",
    "description": "search",
    "version": "2.0.0",
    "params": {
      "query": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "The search query (e.g., \"latest AI news\", \"best restaurants in NYC\")"
      },
      "num": {
        "type": "number",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Number of results to return (e.g., 10, 20, 50)"
      },
      "gl": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Country code for search results (e.g., \"us\", \"uk\", \"de\", \"fr\")"
      },
      "hl": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Language code for search results (e.g., \"en\", \"es\", \"de\", \"fr\")"
      },
      "type": {
        "type": "string",
        "required": false,
        "visibility": "user-or-llm",
        "description": "Type of search to perform. Must be one of \"search\", \"news\", \"places\", \"images\", \"videos\", \"shopping\", \"scholar\", \"patents\" — any other value is rejected."
      },
      "url": {
        "type": "string",
        "required": false,
        "description": "url"
      },
      "urls": {
        "type": "string",
        "required": false,
        "description": "urls"
      },
      "keywords": {
        "type": "string",
        "required": false,
        "description": "keywords"
      },
      "videoId": {
        "type": "string",
        "required": false,
        "description": "videoId"
      },
      "capabilityInput": {
        "type": "string",
        "required": false,
        "description": "capabilityInput"
      }
    },
    "hostedApiKey": "none"
  },
  "wecom_read_document": {
    "id": "wecom_read_document",
    "name": "Read WeCom document",
    "description": "Read the text of an authorized WeDoc document",
    "version": "1.0.0",
    "params": {
      "accessToken": {
        "type": "string",
        "required": true,
        "visibility": "user-only",
        "description": "Connected app access token"
      },
      "documentId": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "WeDoc docid"
      }
    },
    "oauth": {
      "required": true,
      "credentialKind": "service-account",
      "provider": "wecom"
    },
    "hostedApiKey": "none"
  },
  "wecom_send_message": {
    "id": "wecom_send_message",
    "name": "Send WeCom message",
    "description": "Send a text message to enterprise app users",
    "version": "1.0.0",
    "params": {
      "accessToken": {
        "type": "string",
        "required": true,
        "visibility": "user-only",
        "description": "Connected app access token"
      },
      "agentId": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "Enterprise application AgentId"
      },
      "userIds": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "Recipient user IDs separated by |"
      },
      "text": {
        "type": "string",
        "required": true,
        "visibility": "user-or-llm",
        "description": "Message text"
      }
    },
    "oauth": {
      "required": true,
      "credentialKind": "service-account",
      "provider": "wecom"
    },
    "hostedApiKey": "none"
  }
}
